import { useEffect, useState } from "react";

export const WEBINAR_START = new Date("2026-09-17T19:00:00-04:00");

const diff = () => {
  const d = Math.max(0, WEBINAR_START.getTime() - Date.now());
  return {
    days: Math.floor(d / 86400000),
    hours: Math.floor(d / 3600000) % 24,
    mins: Math.floor(d / 60000) % 60,
    secs: Math.floor(d / 1000) % 60,
  };
};

export const Countdown = ({ compact = false }) => {
  const [t, setT] = useState(diff);
  useEffect(() => {
    const id = setInterval(() => setT(diff()), 1000);
    return () => clearInterval(id);
  }, []);
  const cells = [
    { v: t.days, l: "DAYS" },
    { v: t.hours, l: "HRS" },
    { v: t.mins, l: "MIN" },
    { v: t.secs, l: "SEC" },
  ];
  return (
    <div className={`countdown ${compact ? "compact" : ""}`} data-testid="countdown-timer">
      {cells.map((c) => (
        <div className="countdown-cell" key={c.l}>
          <span className="countdown-value" data-testid={`countdown-${c.l.toLowerCase()}`}>{String(c.v).padStart(2, "0")}</span>
          <span className="countdown-label">{c.l}</span>
        </div>
      ))}
    </div>
  );
};
